/* ============
 * Mutations for the exteriors module
 * ============
 *
 * The mutations that are available on the
 * exteriors module.
 */

import {SET_POI_LIST, LOAD, TOGGLE_SHOW_OVERLAY_STATUS, TOGGLE_POI, TOGGLE_POI_MASK} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, exteriors) {
    state.exteriors = exteriors.data;
  },
  [SET_POI_LIST](state, list) {
    state.pois = list.data;
  },
  [TOGGLE_POI](state, isShown) {
    state.isShowTogglePOI = isShown;
  },
  [TOGGLE_POI_MASK](state, showPois) {
    state.isPoiMaskOn = showPois;
  },
  [TOGGLE_SHOW_OVERLAY_STATUS](state, value = !state.globalShowOverlayStatus) {
    state.globalShowOverlayStatus = !!value;
  },
};
